import { Box, Grid } from '@material-ui/core';
import { Alert } from '@dev/ee-components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { UsedEntitiesList } from './components/UsedEntitiesList';
interface DowngradeAlertDialogI {
    list: string[];
    type: 'list' | 'custom_field';
}

export const DeletionNotAllowedDialog = ({ list, type }: DowngradeAlertDialogI) => {
    const { t } = useTranslation();

    const description =
        {
            list: t('cannotdeletelist_forms_used_desc'),
            custom_field: t('cannotdeletecustomfield_forms_used_desc'),
        }[type] || '';

    return (
        <Grid container>
            <Alert severity="warning" body={description as any} />
            <Box mt="16px" width={1} />
            <UsedEntitiesList list={list} />
        </Grid>
    );
};
